<template>
<section>
    <div class="d-flex justify-content-center my-5">
      <h1 class="center title">Womi en chiffres</h1>
    </div> 
    <form class="container mt-8">
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label>Followers</label>
                    <input type="text" class="form-control" v-model="followers" >
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label>Partenaires</label>
                    <input type="text" class="form-control" v-model="partenariats" >
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label>Clients</label>
                    <input type="text" class="form-control" v-model="clients"  >
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label>Salariés</label>
                    <input type="text" class="form-control" v-model="salaries" >
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label>Projet</label>
                    <input type="text" class="form-control" v-model="project">
                </div>
            </div>
        </div>
        <button type="submit" class="btn btn-light me-2" @click.prevent="SaveFollowers" >Enregistrer</button>
    </form>
</section>
</template>
<script>

import axios from 'axios'
import APIs from "@/../config";
export default {
    name : 'SaveFollowers' , 
    data() {
        return {
            followers : 0,
            partenariats : 0 , 
            clients : 0, 
            salaries : 0 ,
            project:0
        }
    },
    created() {
        axios.get(`${APIs.API_URL}/chiffre/`)
        .then(res => {
            if(res.data){
                this.followers = res.data.followers 
                this.partenariats = res.data.partenariats
                this.clients= res.data.clients
                this.salaries = res.data.salaries
                this.project = res.data.project
            }
        })
        .catch(err => console.log(err))
    } , 
    methods : {
        SaveFollowers(){
            var get_token = localStorage.getItem('token')
            var user_id = localStorage.getItem('user_id')
            axios.put(`${APIs.API_URL}/chiffre/${user_id}`,{
                'followers' : this.followers  ,
                'partenariats' : this.partenariats , 
                'clients' : this.clients,
                'salaries' : this.salaries , 
                'project' : this.project,
            }, {
                headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${get_token}`
                }
            })
            .then(() => {
                   this.$swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: "ajoutée",
                    showConfirmButton: false,
                    timer: 1500
                });
                this.$emit("refresh")
            })
            .catch( (error) => {
                this.$swal.fire({
                    position: 'top-end',
                    icon: 'error',
                    title: error.response.data.error,
                    showConfirmButton: false,
                    timer: 1500
                });
            });
            
        }
    }
}
















// import axios from "axios";
// import APIs from "@/../config";
// export default {
//     name: "SaveFollowers" ,
//     async created(){
//         this.followers = this.chiffre.followers
//         this.partenariat = this.chiffre.partenariat
//         this.clients = this.chiffre.clients
//         this.salarie = this.chiffre.salarie
//         this.project = this.chiffre.project
//     },
//     methods : {
//         SaveFollowers(){
//             var get_token = localStorage.getItem('token')
//             var user_id = localStorage.getItem('user_id')
//             axios.put(`${APIs.API_URL}/chiffre/${user_id}/${this.chiffre._id}`, {
//                 'followers' : this.chiffre.Followers  ,
//                 'partenariat' : this.chiffre.Partenaires , 
//                 'clients' : this.chiffre.Clients,
//                 'salarie' : this.chiffre.Salariés , 
//                 'project' : this.chiffre.Projet,
//             }, {
//                 headers: {
//                 'Content-Type': 'application/json',
//                 Authorization: `Bearer ${get_token}`
//                 }
//             })
//         }
//     }
// }

// import axios from "axios";
// import APIs from "@/../config";
// export default {
//     name: "SaveFollowers" ,
//     async created(){
//         // set props
//         this.Followers = this.chiffre.Followers
//         this.Partenaires = this.chiffre.Partenaires
//         this.Clients = this.chiffre.Clients
//         this.Salariés = this.chiffre.Salariés
//         this.Projet = this.chiffre.Projet
//     },
//        methods : {
//         SaveFollowers(){
//             var get_token = localStorage.getItem('token')
//             var user_id = localStorage.getItem('user_id')
//             axios.put(`${APIs.API_URL}/chiffre/${user_id}/${this.chiffre._id}`, {
//                 'Followers' : this.chiffre.Followers  ,
//                 'Partenaires' : this.chiffre.Partenaires , 
//                 'Clients' : this.chiffre.Clients,
//                 'Salariés' : this.chiffre.Salariés , 
//                 'Projet' : this.chiffre.Projet,
//             }, {
//                 headers: {
//                 'Content-Type': 'application/json',
//                 Authorization: `Bearer ${get_token}`
//                 }
//             })
//         }
//     }
// }

</script>
<style lang="scss" scoped>
  .title{
    color:white;
  }
</style>



